<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="hidden">
    <symbol id="arrow-left" viewBox="0 0 6 9" fill="currentColor">
      <path
        d="M5.99987 4.4903C5.99804 4.28876 5.90703 4.09575 5.74612 3.95214L1.5096 0.228648C1.34428 0.0827036 1.11977 0.000458704 0.885451 1.91287e-06C0.651135 -0.000454878 0.42621 0.080916 0.260156 0.226215C0.0941022 0.371514 0.000521923 0.568842 2.17655e-06 0.774783C-0.00051757 0.980723 0.0920656 1.17841 0.257384 1.32435L3.87057 4.5L0.257384 7.67565C0.0920656 7.82159 -0.000517561 8.01928 2.17655e-06 8.22522C0.000521915 8.43116 0.0941022 8.62848 0.260156 8.77378C0.42621 8.91907 0.651135 9.00045 0.885451 9C1.11977 8.99954 1.34428 8.9173 1.5096 8.77135L5.74612 5.04785C5.82845 4.9744 5.8933 4.88726 5.93686 4.79153C5.98043 4.6958 6.00185 4.59339 5.99987 4.4903Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="loan" viewBox="0 0 61 70" fill="none" stroke="currentColor">
      <g clip-path="url(#clip0_57_86841)">
        <path
          d="M41.4229 55.7288L45.5275 59.8426L52.2217 53.1484"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M29.5039 51.1283H4.36157C2.33219 51.1283 0.688477 49.4846 0.688477 47.4552V4.36059C0.688477 2.33121 2.33219 0.6875 4.36157 0.6875H37.6214C39.6508 0.6875 41.2945 2.33121 41.2945 4.36059V38.098"
          stroke="#020038"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.37451 9.375H22.8465"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.37451 15.168H33.6179"
          stroke="#020038"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.6011 24.3984H33.0666"
          stroke="#020038"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.6011 31.6875H33.0666"
          stroke="#020038"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.6011 38.9883H33.0666"
          stroke="#020038"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.37451 24.3984H10.5141"
          stroke="#020038"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.37451 31.6875H10.5141"
          stroke="#020038"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.37451 38.9883H10.5141"
          stroke="#020038"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M45.877 9.88672H47.0799C49.1093 9.88672 50.753 11.5304 50.753 13.5598V38.4909"
          stroke="#020038"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M29.0813 60.3303H13.8196C11.7902 60.3303 10.1465 58.6866 10.1465 56.6572V55.6562"
          stroke="#020038"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M46.8225 69.3101C53.9023 69.3101 59.6416 63.5708 59.6416 56.491C59.6416 49.4112 53.9023 43.6719 46.8225 43.6719C39.7427 43.6719 34.0034 49.4112 34.0034 56.491C34.0034 63.5708 39.7427 69.3101 46.8225 69.3101Z"
          stroke="#54B7F9"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_57_86841">
          <rect width="60.3306" height="70" fill="white" />
        </clipPath>
      </defs>
    </symbol>
    <symbol id="todo-completed" viewBox="0 0 145 116" fill="none" stroke="currentColor">
      <path
        d="M36.1479 24.6948V8.37145C36.1479 5.60702 38.3858 3.36914 41.1503 3.36914H108.418C111.183 3.36914 113.421 5.60702 113.421 8.37145V94.9904C113.421 97.7549 111.183 99.9928 108.418 99.9928H41.1503C38.3858 99.9928 36.1479 97.7549 36.1479 94.9904V76.5609"
        stroke="#020038"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M119.081 18.377H124.083C126.848 18.377 129.086 20.6148 129.086 23.3793V109.998C129.086 112.763 126.848 115.001 124.083 115.001H56.8153C54.0509 115.001 51.813 112.763 51.813 109.998V107.365"
        stroke="#020038"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M36.806 69.1892C47.3479 69.1892 55.8938 60.6433 55.8938 50.1014C55.8938 39.5596 47.3479 31.0137 36.806 31.0137C26.2641 31.0137 17.7183 39.5596 17.7183 50.1014C17.7183 60.6433 26.2641 69.1892 36.806 69.1892Z"
        stroke="#54B7F9"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M46.8105 43.3887L33.3833 56.8159L26.8013 50.3656"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M52.0762 16.6641H74.7182"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M52.0762 27.7227H99.2032"
        stroke="#020038"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M61.8174 40.4922H99.2031"
        stroke="#020038"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M61.8174 53.1289H99.2031"
        stroke="#020038"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M61.8174 65.7676H99.2031"
        stroke="#020038"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M61.8174 78.4043H99.2031"
        stroke="#020038"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M126.189 1V5.34411"
        stroke="#020038"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M128.427 3.10547H124.083"
        stroke="#020038"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.10596 54.5781V58.9222"
        stroke="#020038"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.34411 56.6836H1"
        stroke="#020038"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M141.196 95.6484V100.124"
        stroke="#020038"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M143.434 97.8867H139.09"
        stroke="#020038"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="dashboard" viewBox="0 0 32 25" fill="none" stroke="currentColor">
      <path
        d="M25.7836 12.0254V24.2547H6.52246V12.0254"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M0.81543 11.5151L15.6944 0.814453L31.1849 11.9227"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.6499 15.5918H13.3506V24.2542H18.6499V15.5918Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="application" viewBox="0 0 32 25" fill="none" stroke="currentColor">
      <path
        d="M27.3 1H5V18.3H27.3V1Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.1001 23H20.1001"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.1001 18.1992V22.9992"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 13.5H27.3"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="contact" viewBox="0 0 32 25" fill="none" stroke="currentColor">
      <path
        d="M22.6812 18.8646H24.607C26.441 18.8646 28 17.3974 28 15.4716V6.39301C28 4.55895 26.5328 3 24.607 3H10.393C8.55895 3 7 4.46725 7 6.39301V15.4716V22.2576L13.3275 18.8646H17.5459"
        stroke="#currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="settings" viewBox="0 0 32 25" fill="none" stroke="currentColor">
      <g clip-path="url(#clip0_319_68556)">
        <path
          d="M12.0693 4.78355L9.77922 2.99134L6.99134 5.77922L8.78355 8.06926C8.38528 8.76623 8.08658 9.4632 7.88745 10.1602L5 10.5584V14.5411L7.88745 14.9394C8.08658 15.6364 8.38528 16.3333 8.78355 17.0303L6.99134 19.2208L9.77922 22.0087L12.0693 20.2165C12.6667 20.6147 13.3636 20.9134 14.1602 21.1126L14.5584 24H18.5411L18.9394 21.1126C19.6364 20.9134 20.3333 20.6147 21.0303 20.2165L23.3203 22.0087L26.1082 19.2208L24.2165 16.9307C24.6147 16.3333 24.9134 15.6364 25.1126 14.8398L28 14.4416V10.4589L25.1126 10.0606C24.9134 9.36364 24.6147 8.66667 24.2165 7.9697L26.0087 5.67965L23.2208 2.99134L20.9307 4.78355C20.3333 4.38528 19.6364 4.08658 18.8398 3.88745L18.4416 1H14.4589"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.5499 15.7356C18.3096 15.7356 19.7361 14.3091 19.7361 12.5494C19.7361 10.7898 18.3096 9.36328 16.5499 9.36328C14.7903 9.36328 13.3638 10.7898 13.3638 12.5494C13.3638 14.3091 14.7903 15.7356 16.5499 15.7356Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_319_68556">
          <rect width="32" height="24.9682" fill="white" />
        </clipPath>
      </defs>
    </symbol>
    <symbol id="faq" viewBox="0 0 32 25" fill="none" stroke="currentColor">
      <g clip-path="url(#clip0_319_68565)">
        <path
          d="M20.2338 23.2035C19.039 23.6017 17.7446 23.8009 16.4502 23.8009C10.0779 23.8009 5 18.7229 5 12.3507C5 5.97835 10.1775 1 16.5498 1C22.9221 1 28 6.07792 28 12.4502C28 15.3377 26.9048 17.9264 25.2121 19.9178"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.4634 8.86664C13.4634 8.86664 13.7621 6.67617 16.4504 6.47703C18.7404 6.2779 20.2339 7.57227 20.4331 10.0614C20.5326 11.7541 18.5413 13.2476 17.5456 13.4467C16.8487 13.6459 16.3508 14.2433 16.3508 15.0398V15.3385"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.251 18.0273V18.4256"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_319_68565">
          <rect width="32" height="24.9682" fill="white" />
        </clipPath>
      </defs>
    </symbol>
    <symbol id="app-sub-active" viewBox="0 0 31 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.9569 12.1379V5.25C21.9569 2.90517 20.0517 1 17.7069 1H5.25C2.75862 1 1 2.75862 1 5.25V30.75C1 33.0948 2.75862 35 5.25 35H17.8534C20.1983 35 22.1034 33.0948 22.1034 30.75V23.569"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.9569 7.1543H1"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.9569 28.6992H1"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.707 18H29.2846"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M25.3276 14.043L29.4311 18.1464L25.3276 22.2499"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9917 22.25H17.4141"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.8706 13.1641H17.8534"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="app_sub_icon" viewBox="0 0 31 36" fill="none" stroke="currentColor">
      <g>
        <path
          d="M21.9569 12.1379V5.25C21.9569 2.90517 20.0517 1 17.7069 1H5.25C2.75862 1 1 2.75862 1 5.25V30.75C1 33.0948 2.75862 35 5.25 35H17.8534C20.1983 35 22.1034 33.0948 22.1034 30.75V23.569"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.9569 7.1543H1"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.9569 28.6992H1"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.707 18H29.2846"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M25.3276 14.043L29.4311 18.1464L25.3276 22.2499"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.9917 22.25H17.4141"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.8706 13.1641H17.8534"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </symbol>
    <symbol id="conditonal_off_icon" viewBox="0 0 31 36" fill="none" stroke="currentColor">
      <path
        d="M25.4464 9.92704V6.21888L20.0901 1H16.382H1V32.8627L25.4464 33V30.6652"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.0903 1V7.18026H24.7599"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.18018 10.6133H19.266"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.18018 15.832H14.5965"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M29.0171 17.8926L24.4849 22.4248L22.4248 20.3647"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M25.4463 27.3692C29.3905 27.3692 32.5879 24.1718 32.5879 20.2276C32.5879 16.2834 29.3905 13.0859 25.4463 13.0859C21.5021 13.0859 18.3047 16.2834 18.3047 20.2276C18.3047 24.1718 21.5021 27.3692 25.4463 27.3692Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="supporting_doc_icon" viewBox="0 0 28 34" fill="none" stroke="currentColor">
      <path
        d="M3.82352 27.3085H17.7512C19.2532 27.3085 20.6187 26.0796 20.6187 24.441V3.82255C20.6187 2.32054 19.3898 0.955078 17.7512 0.955078H3.82352C2.32152 0.955078 0.956055 2.18399 0.956055 3.82255V24.5776C1.0926 26.0796 2.32152 27.3085 3.82352 27.3085Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.51025 30.5849V31.131C7.51025 32.0869 8.32953 32.9061 9.28535 32.9061H25.1247C26.0805 32.9061 26.8998 32.0869 26.8998 31.131V8.32783C26.8998 7.37201 26.0805 6.55273 25.1247 6.55273H24.1689"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.5542 7.91797H15.0201"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.5542 12.1523H15.0201"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.5542 16.5215H15.0201"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="unconditonal_off_icon" viewBox="0 0 32 34" fill="none" stroke="currentColor">
      <path
        d="M25.4464 9.92704V6.21888L20.0901 1H16.382H1V32.8627L25.4464 33V30.6652"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.0903 1V7.18026H24.7599"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.18018 10.6133H19.266"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.18018 15.832H14.5965"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M30.6652 19.8145H20.3647V27.6428H30.6652V19.8145Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.4634 19.8148V16.7934C21.4634 14.596 23.2488 12.8105 25.4462 12.8105C27.6436 12.8105 29.429 14.596 29.429 16.7934V19.8148"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M25.4464 24.8966C26.0532 24.8966 26.5451 24.4047 26.5451 23.7979C26.5451 23.1911 26.0532 22.6992 25.4464 22.6992C24.8396 22.6992 24.3477 23.1911 24.3477 23.7979C24.3477 24.4047 24.8396 24.8966 25.4464 24.8966Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="loan_settle_active" viewBox="0 0 32 32" fill="none" stroke="currentColor">
      <path
        d="M23.9036 9.38076V5.91088L18.8915 1.02734H15.4217H1.02808V30.8426L23.9036 30.9711V28.7864"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.8916 1.02734V6.81048H23.2611"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.81128 10.0234H18.1205"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.81128 14.9062H13.751"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23.9036 12.3379C27.502 12.3379 30.5863 15.2937 30.5863 19.0206C30.5863 22.7475 27.6305 25.7034 23.9036 25.7034"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23.9037 25.5744C20.3053 25.5744 17.2209 22.6186 17.2209 18.8917C17.2209 15.1648 20.1768 12.209 23.9037 12.209"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22.2331 20.5609C22.2331 21.4605 23.1327 21.9745 24.1608 21.9745C25.1889 21.9745 25.703 21.2035 25.703 20.4324C25.703 19.6613 24.8034 19.1472 23.9038 19.1472C22.8757 19.1472 21.9761 18.3761 21.9761 17.4765C21.9761 16.5769 22.8757 16.1914 23.9038 16.1914C24.9319 16.1914 25.5745 16.7055 25.5745 17.348"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.0322 16.0637V15.1641"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.0322 22.7473V21.8477"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="uncomplete_task_icon" viewBox="0 0 108 112" fill="none" stroke="currentColor">
      <path
        d="M84.125 81.375V105.625C84.125 108.5 81.75 111 78.75 111H6.375C3.5 111 1 108.625 1 105.625V11.25C1 8.375 3.375 5.875 6.375 5.875H20.125"
        stroke="#020038"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M71.5 6H78.875C81.75 6 84.25 8.375 84.25 11.375V41.875"
        stroke="#020038"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M62.5 11.25H22.625C21.375 11.25 20.375 10.25 20.375 9V3.25C20.375 2 21.375 1 22.625 1H62.5C63.75 1 64.75 2 64.75 3.25V9C64.75 10.25 63.75 11.25 62.5 11.25Z"
        stroke="#020038"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M73.625 79.125L63.375 79.625L63.875 69.375L96.375 36.875L106.125 46.625L73.625 79.125Z"
        stroke="#54B7F9"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M31.625 35.25H69.375"
        stroke="#020038"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M31.625 59.875H63.375"
        stroke="#020038"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M31.625 84.5H69.375"
        stroke="#020038"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23.75 29.875H11.125V42.5H23.75V29.875Z"
        stroke="#020038"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.5 34.25L16.5 38.375L14.625 36.5"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23.75 53.25H11.125V65.875H23.75V53.25Z"
        stroke="#020038"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.5 57.625L16.5 61.625L14.625 59.875"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23.75 76.625H11.125V89.25H23.75V76.625Z"
        stroke="#020038"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.5 81L16.5 85L14.625 83.25"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="loan_summary_icon" viewBox="0 0 25 26" fill="none" stroke="currentColor">
      <g clip-path="url(#clip0_57_73278)">
        <path
          d="M18.5934 11.727V4.32045L14.813 0.617188H0.617188V23.1454H10.724"
          stroke="#020038"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.5934 4.32045L14.813 0.617188V4.32045H18.5934Z"
          stroke="#020038"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.552 7.63867H14.0416"
          stroke="#020038"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.552 11.6504H14.0416"
          stroke="#54B7F9"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.552 15.7383H8.40957"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.2819 23.8402C19.8811 23.8402 21.9881 21.7331 21.9881 19.134C21.9881 16.5348 19.8811 14.4277 17.2819 14.4277C14.6827 14.4277 12.5757 16.5348 12.5757 19.134C12.5757 21.7331 14.6827 23.8402 17.2819 23.8402Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.6765 22.6055L23.5311 25.3829"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_57_73278">
          <rect width="24.1484" height="26" fill="white" />
        </clipPath>
      </defs>
    </symbol>
    <symbol id="supporting_document" viewBox="0 0 23 27" fill="none" stroke="currentColor">
      <path
        d="M3.24335 21.6197H14.1408C15.316 21.6197 16.3844 20.6581 16.3844 19.3761V3.24359C16.3844 2.06838 15.4228 1 14.1408 1H3.24335C2.06813 1 0.999756 1.96154 0.999756 3.24359V19.4829C1.10659 20.6581 2.06813 21.6197 3.24335 21.6197Z"
        stroke="#020038"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.12802 24.1843V24.6116C6.12802 25.3595 6.76905 26.0005 7.51691 26.0005H19.9101C20.6579 26.0005 21.299 25.3595 21.299 24.6116V6.76975C21.299 6.02188 20.6579 5.38086 19.9101 5.38086H19.1622"
        stroke="#020038"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.3799 6.44922H12.0038"
        stroke="#020038"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.3799 9.75977H12.0038"
        stroke="#54B7F9"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.3799 13.1797H12.0038"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="events" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path d="M7 2V4" stroke="#A6A1C0" stroke-width="1.5" stroke-linecap="round" />
      <path d="M17 2V4" stroke="#A6A1C0" stroke-width="1.5" stroke-linecap="round" />
      <rect x="3" y="5" width="18" height="16" rx="2" stroke="#A6A1C0" stroke-width="1.5" />
      <path d="M3 9H21" stroke="#A6A1C0" stroke-width="1.5" />

      <circle cx="7" cy="12" r="1" fill="#A6A1C0" />
      <circle cx="12" cy="12" r="1" fill="#A6A1C0" />
      <circle cx="17" cy="12" r="1" fill="#A6A1C0" />
      <circle cx="7" cy="16" r="1" fill="#A6A1C0" />
      <circle cx="12" cy="16" r="1" fill="#A6A1C0" />
      <circle cx="17" cy="16" r="1" fill="#A6A1C0" />
    </symbol>
    <symbol
      id="trash"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M1.712,4.475l16.576,-0" />
      <path
        d="M6.317,4.475l-0,-1.842c-0,-0.488 0.194,-0.957 0.539,-1.302c0.345,-0.345 0.814,-0.539 1.302,-0.539l3.684,-0c0.488,-0 0.957,0.194 1.302,0.539c0.345,0.345 0.539,0.814 0.539,1.302l0,1.842m2.763,-0l-0,12.892c-0,0.488 -0.194,0.957 -0.54,1.302c-0.345,0.345 -0.813,0.539 -1.302,0.539l-9.208,0c-0.489,0 -0.957,-0.194 -1.302,-0.539c-0.346,-0.345 -0.54,-0.814 -0.54,-1.302l0,-12.892l12.892,-0Z"
      />
      <path d="M8.158,9.079l0,5.525" />
      <path d="M11.842,9.079l-0,5.525" />
    </symbol>
    <symbol id="chl_logo" viewBox="0 0 100 29" preserveAspectRatio="xMinYMid meet" fill="none">
      <path
        d="M39.7524 5.3224C39.0341 4.84861 38.2585 4.60407 37.3949 4.60407C35.6412 4.60407 34.4796 5.81147 34.4796 7.76394C34.4796 9.71641 35.6144 10.9964 37.4255 10.9964C38.3463 10.9964 39.2213 10.6525 39.8823 10.1902L40.2109 11.7988C39.4926 12.2306 38.3731 12.5018 37.3529 12.5018C34.5942 12.5018 32.7144 10.7633 32.7144 7.81743C32.7144 4.87153 34.5981 3.091 37.3988 3.091C38.4495 3.091 39.5232 3.36229 40.2988 3.79405L39.7524 5.31858V5.3224Z"
        fill="white"
      />
      <path
        d="M44.4789 12.5058C42.5379 12.5058 41.1318 11.1838 41.1318 8.98679C41.1318 6.78979 42.6105 5.43719 44.5668 5.43719C46.5231 5.43719 47.9139 6.78597 47.9139 8.97151C47.9139 11.1571 46.4199 12.5058 44.4789 12.5058ZM44.5057 6.80125C43.3976 6.80125 42.7977 7.69151 42.7977 8.97151C42.7977 10.2515 43.4282 11.1265 44.5362 11.1265C45.6443 11.1265 46.2327 10.263 46.2327 8.98679C46.2327 7.71062 45.6023 6.80507 44.5095 6.80507L44.5057 6.80125Z"
        fill="white"
      />
      <path
        d="M53.6452 12.2917V8.25306C53.6452 7.27492 53.2592 6.94632 52.4951 6.94632C51.9067 6.94632 51.3603 7.24817 51.0317 7.5653V12.2917H49.3352V5.69689L51.0317 5.46764V6.51838C51.6201 5.87265 52.411 5.45618 53.2134 5.45618C54.5507 5.45618 55.3378 6.3197 55.3378 7.74106V12.2956H53.6413L53.6452 12.2917Z"
        fill="white"
      />
      <path
        d="M61.4168 12.2917V8.25306C61.4168 7.27492 61.0271 6.94632 60.2667 6.94632C59.6783 6.94632 59.1319 7.24817 58.7995 7.5653V12.2917H57.103V5.69689L58.7995 5.46764V6.51838C59.3879 5.87265 60.1788 5.45618 60.9812 5.45618C62.3185 5.45618 63.1056 6.3197 63.1056 7.74106V12.2956H61.4092L61.4168 12.2917Z"
        fill="white"
      />
      <path
        d="M66.1585 9.34587C66.2311 10.4234 66.9647 11.157 68.1415 11.157C68.8446 11.157 69.6049 10.9277 70.2086 10.5533L70.4226 11.9594C69.7922 12.3032 68.9133 12.5057 68.0231 12.5057C65.8987 12.5057 64.4888 11.157 64.4888 9.04402C64.4888 6.93107 65.9254 5.45239 67.9085 5.45239C69.6622 5.45239 70.6366 6.5146 70.6366 8.13847C70.6366 8.49763 70.5793 8.95614 70.4914 9.24653C70.4761 9.24653 66.1547 9.30384 66.1547 9.30384V9.34587H66.1585ZM69.0433 8.29513V8.1805C69.0433 7.29024 68.6574 6.72857 67.7785 6.72857C66.8463 6.72857 66.2846 7.48892 66.2005 8.31041L69.0433 8.29513Z"
        fill="white"
      />
      <path
        d="M75.0917 12.5057C72.9367 12.5057 71.6567 11.1684 71.6567 9.00199C71.6567 6.83555 73.0628 5.45239 75.149 5.45239C76.0546 5.45239 76.8302 5.6549 77.4339 6.01406L77.0747 7.37812C76.5284 7.03424 75.8979 6.84701 75.2789 6.84701C74.0562 6.84701 73.3952 7.67997 73.3952 8.95996C73.3952 10.3087 74.1556 11.0997 75.2789 11.0997C75.9667 11.0997 76.601 10.9124 77.1168 10.5838L77.3881 11.9632C76.8149 12.3071 75.9782 12.5096 75.0879 12.5096L75.0917 12.5057Z"
        fill="white"
      />
      <path
        d="M81.1402 12.5056C79.6615 12.5056 78.8859 11.8598 78.9432 10.2627L79.0425 7.14488L78.0071 7.03025L78.0491 5.95276L79.0846 5.62416L79.1113 4.16077H80.7505L80.7199 5.71204H82.5883L82.5463 7.10667H80.6206L80.5327 10.1672C80.5174 10.7862 80.8345 11.0727 81.4077 11.0727C81.7515 11.0727 82.0954 10.9849 82.4431 10.8702L82.6724 12.2496C82.168 12.4215 81.7095 12.5094 81.1364 12.5094L81.1402 12.5056Z"
        fill="white"
      />
      <path
        d="M84.7891 4.45887C84.1281 4.45887 83.7537 4.05768 83.7537 3.43869C83.7537 2.81971 84.1281 2.41852 84.7891 2.41852C85.4501 2.41852 85.836 2.83499 85.836 3.43869C85.836 4.04239 85.4616 4.45887 84.7891 4.45887ZM83.9409 12.2917V5.71212L85.6374 5.46758V12.2917H83.9409Z"
        fill="white"
      />
      <path
        d="M90.8681 12.3033H89.057L86.5276 5.66638H88.3387L90.0046 10.5074L91.5979 5.66638H93.4205L90.8643 12.3033H90.8681Z"
        fill="white"
      />
      <path
        d="M95.522 9.34587C95.5946 10.4234 96.3282 11.157 97.5051 11.157C98.2081 11.157 98.9685 10.9277 99.5722 10.5533L99.7861 11.9594C99.1557 12.3032 98.2769 12.5057 97.3866 12.5057C95.2622 12.5057 93.8523 11.157 93.8523 9.04402C93.8523 6.93107 95.289 5.45239 97.272 5.45239C99.0258 5.45239 100 6.5146 100 8.13847C100 8.49763 99.9428 8.95614 99.8549 9.24653C99.8396 9.24653 95.5182 9.30384 95.5182 9.30384V9.34587H95.522ZM98.4106 8.29513V8.1805C98.4106 7.29024 98.0209 6.72857 97.1459 6.72857C96.2136 6.72857 95.6519 7.48892 95.5641 8.31041L98.4106 8.29513Z"
        fill="white"
      />
      <path
        d="M40.1269 21.9433C40.1269 23.4219 39.2366 24.5147 36.6346 24.5147H33.1423V15.5356H36.5773C39.0036 15.5356 39.8403 16.5405 39.8403 17.9046C39.8403 18.8675 39.2672 19.5132 38.2317 19.8571C39.4086 20.1169 40.1269 20.8772 40.1269 21.9394V21.9433ZM36.52 16.9455H34.8694V19.3871H36.3786C37.4981 19.3871 38.0866 18.9133 38.0866 18.1377C38.0866 17.362 37.5402 16.9455 36.52 16.9455ZM36.478 20.6671H34.8694V23.1086H36.6079C37.7847 23.1086 38.3617 22.6922 38.3617 21.8745C38.3617 20.9842 37.586 20.6671 36.4818 20.6671H36.478Z"
        fill="white"
      />
      <path
        d="M43.2294 24.5186H41.533V17.939L43.2294 17.6945V18.772C43.6459 18.0689 44.177 17.6792 44.9526 17.6792C45.3538 17.6792 45.7703 17.7671 46.1295 17.981L45.755 19.5056C45.4379 19.3336 45.1246 19.2458 44.8075 19.2458C44.219 19.2458 43.6727 19.6202 43.2256 20.4226V24.5186H43.2294Z"
        fill="white"
      />
      <path
        d="M47.9979 16.6857C47.3369 16.6857 46.9624 16.2845 46.9624 15.6656C46.9624 15.0466 47.3369 14.6454 47.9979 14.6454C48.6589 14.6454 49.0448 15.0619 49.0448 15.6656C49.0448 16.2693 48.6703 16.6857 47.9979 16.6857ZM47.1496 24.5185V17.939L48.8461 17.6944V24.5185H47.1496Z"
        fill="white"
      />
      <path
        d="M55.0243 14.9205L56.7208 14.6912V24.5185H55.0243V23.8728C54.5773 24.3046 53.9774 24.7363 53.1559 24.7363C51.4021 24.7363 50.2673 23.315 50.2673 21.2593C50.2673 19.2037 51.7307 17.683 53.6144 17.683C54.0882 17.683 54.604 17.7709 55.0205 17.8969V14.9243L55.0243 14.9205ZM53.7711 19.0279C52.6363 19.0279 51.9906 19.9602 51.9906 21.1829C51.9906 22.4744 52.6363 23.2958 53.6565 23.2958C54.2181 23.2958 54.6461 23.0933 55.0205 22.7495C55.0205 22.8068 55.0205 19.4177 55.0205 19.4177C54.6919 19.1731 54.2716 19.0317 53.7711 19.0317V19.0279Z"
        fill="white"
      />
      <path
        d="M58.1539 23.6398C58.1539 23.0361 58.6429 22.4897 59.3766 22.2452C58.6429 21.8707 58.1692 21.1257 58.1692 20.2048C58.1692 18.8408 59.2466 17.6754 61.0845 17.6754C61.8334 17.6754 62.4944 17.8894 62.9529 18.0919L64.7334 17.9352L64.806 19.4139L63.5413 19.1999C63.7133 19.3872 63.8432 19.8877 63.8432 20.2354C63.8432 21.5842 62.7084 22.6502 61.0692 22.6502C60.7521 22.6502 60.5228 22.6196 60.1637 22.5356C59.9344 22.6235 59.6478 22.8374 59.6478 23.1087C59.6478 23.4679 59.9497 23.6245 61.0119 23.6245C61.0119 23.6245 61.8028 23.6245 61.6996 23.6245C63.5948 23.6245 64.6723 24.1556 64.6723 25.4471C64.6723 27.0136 62.907 28.0911 60.8094 28.0911C59.0556 28.0911 57.6648 27.4454 57.6648 26.2533C57.6648 25.5655 58.1692 24.9466 59.1588 24.7899C58.5856 24.5874 58.1539 24.1709 58.1539 23.6398ZM59.2046 25.9094C59.2046 26.5284 59.965 26.9602 61.0845 26.9602C62.204 26.9602 63.1401 26.5284 63.1401 25.8406C63.1401 25.2217 62.5364 25.0803 61.3023 25.0803C60.8858 25.0803 60.3127 25.0497 60.0376 25.023C59.5638 25.1949 59.2046 25.512 59.2046 25.9132V25.9094ZM61.0998 21.5421C61.8601 21.5421 62.2919 20.9958 62.2919 20.1628C62.2919 19.3719 61.8754 18.8255 61.0272 18.8255C60.2783 18.8255 59.8045 19.3872 59.8045 20.2201C59.8045 21.011 60.2783 21.5421 61.0959 21.5421H61.0998Z"
        fill="white"
      />
      <path
        d="M67.0181 21.5727C67.0907 22.6502 67.8243 23.3838 69.0012 23.3838C69.7042 23.3838 70.4645 23.1545 71.0682 22.7801L71.2822 24.1862C70.6518 24.53 69.773 24.7325 68.8827 24.7325C66.7583 24.7325 65.3484 23.3838 65.3484 21.2708C65.3484 19.1579 66.785 17.6792 68.7681 17.6792C70.5219 17.6792 71.4962 18.7414 71.4962 20.3653C71.4962 20.7244 71.4389 21.1829 71.351 21.4733C71.3357 21.4733 67.0143 21.5306 67.0143 21.5306V21.5727H67.0181ZM69.9067 20.5219V20.4073C69.9067 19.517 69.5208 18.9554 68.642 18.9554C67.7097 18.9554 67.148 19.7157 67.064 20.5372L69.9067 20.5219Z"
        fill="white"
      />
      <path
        d="M13.6367 27.2773C21.1677 27.2773 27.2734 21.1715 27.2734 13.6367C27.2734 6.10195 21.1677 0 13.6367 0C6.10577 0 0 6.10577 0 13.6367C0 21.1677 6.10577 27.2773 13.6367 27.2773Z"
        fill="#4F92CE"
      />
      <path
        d="M13.6254 12.2918C14.3399 12.2918 14.9206 12.8726 14.9206 13.5871C14.9206 14.3016 14.3399 14.8824 13.6254 14.8824C12.9109 14.8824 12.3301 14.3016 12.3301 13.5871C12.3301 12.8726 12.9109 12.2918 13.6254 12.2918Z"
        fill="white"
      />
      <path
        d="M18.1568 13.5834C18.1568 12.8689 18.7376 12.292 19.4482 12.292C20.1589 12.292 20.7435 12.8727 20.7435 13.5834C20.7435 14.2941 20.1628 14.8787 19.4482 14.8787C18.7337 14.8787 18.1568 14.3017 18.1568 13.5834ZM10.3851 7.76804C10.3851 9.20087 9.22739 10.3586 7.79838 10.3586H7.79456C6.01021 10.3586 4.56592 11.8067 4.56592 13.5911C4.56592 15.3754 6.01403 16.8235 7.79838 16.8235C9.22739 16.8235 10.3851 17.9813 10.3851 19.4103C10.3851 21.1984 11.8332 22.6427 13.6176 22.6427C15.4019 22.6427 16.8539 21.1946 16.8539 19.4103C16.8539 17.9813 18.0116 16.8235 19.4406 16.8235C21.2288 16.8235 22.6731 15.3754 22.6731 13.5911C22.6731 11.8067 21.225 10.3586 19.4406 10.3586C17.6563 10.3586 16.2081 11.8029 16.2081 13.5911C16.2081 15.0201 15.0504 16.1816 13.6214 16.1816C12.1924 16.1816 11.0385 15.0239 11.0385 13.5949C11.0385 12.162 12.2 11.0081 13.6252 11.0081C15.4134 11.0081 16.8615 9.56003 16.8615 7.77568C16.8615 5.99133 15.4134 4.54321 13.6252 4.54321C11.8371 4.54321 10.3928 5.98751 10.3928 7.77568"
        fill="white"
      />
    </symbol>
    <symbol id="aussie_logo" viewBox="0 0 150 29" preserveAspectRatio="xMinYMid meet" fill="none">
      <g clip-path="url(#clip0_969_5336)">
        <path
          d="M66.0903 3.71532C66.0903 3.5799 65.9774 3.46704 65.842 3.46704H63.8933C63.7579 3.46704 63.645 3.5799 63.645 3.71532V13.4585C63.645 13.594 63.7579 13.7068 63.8933 13.7068H65.842C65.9774 13.7068 66.0903 13.6015 66.0903 13.4585V3.71532Z"
          fill="white"
        />
        <path
          d="M51.3211 8.83935L48.7705 7.13899C48.1836 6.73271 47.9128 6.38662 47.973 6.01043C48.1235 5.14521 49.3423 5.31825 49.3423 5.31825C50.4333 5.35587 51.5393 5.52892 52.6152 5.7471C52.7281 5.76967 52.8108 5.70196 52.8108 5.59663C52.8108 5.10006 52.7958 4.6035 52.7882 4.09941C52.7882 3.99408 52.698 3.89627 52.5851 3.8737C51.3512 3.63294 50.0947 3.49751 48.8457 3.48999C48.8457 3.48999 45.7158 3.49751 45.7158 6.04805C45.7158 6.82299 46.0092 7.71832 47.025 8.44812L49.7035 10.2312C50.343 10.6676 50.6289 11.0137 50.5612 11.4049C50.4107 12.2702 49.1918 12.0971 49.1918 12.0971C48.1009 12.0595 46.9949 11.8865 45.919 11.6683C45.8061 11.6457 45.7158 11.7134 45.7233 11.8187C45.7309 12.3153 45.7384 12.8119 45.7459 13.316C45.7459 13.4213 45.8362 13.5266 45.9491 13.5417C47.183 13.7824 48.4395 13.9179 49.6884 13.9329C49.6884 13.9329 52.8108 13.9254 52.8108 11.3748C52.8108 10.5548 52.4873 9.59924 51.3211 8.84687"
          fill="white"
        />
        <path
          d="M60.0266 8.83935L57.476 7.13899C56.8892 6.73271 56.6183 6.38662 56.686 6.01043C56.8365 5.14521 58.0478 5.31825 58.0478 5.31825C59.1388 5.35587 60.2448 5.52892 61.3207 5.7471C61.4336 5.76967 61.5239 5.70196 61.5163 5.59663C61.5088 5.10006 61.5013 4.6035 61.4862 4.09941C61.4862 3.99408 61.3959 3.89627 61.2831 3.8737C60.0492 3.63294 58.7927 3.49751 57.5437 3.48999C57.5437 3.48999 54.4213 3.49751 54.4213 6.04805C54.4213 6.82299 54.7148 7.71832 55.723 8.44812L58.4015 10.2312C59.041 10.6676 59.3269 11.0137 59.2592 11.4049C59.1087 12.2702 57.8898 12.0971 57.8898 12.0971C56.7989 12.0595 55.6929 11.8865 54.617 11.6683C54.5041 11.6457 54.4138 11.7134 54.4213 11.8187C54.4289 12.3153 54.4364 12.8119 54.4514 13.316C54.4514 13.4213 54.5417 13.5266 54.6546 13.5417C55.8885 13.7824 57.145 13.9179 58.3939 13.9329C58.3939 13.9329 61.5163 13.9254 61.5163 11.3748C61.5163 10.5548 61.1928 9.59924 60.0266 8.84687"
          fill="white"
        />
        <path
          d="M66.0903 0.133781C66.0903 -0.00164633 65.9774 -0.114502 65.842 -0.114502H63.8933C63.7579 -0.114502 63.645 -0.00164633 63.645 0.133781V1.97709C63.645 2.11252 63.7579 2.22537 63.8933 2.22537H65.842C65.9774 2.22537 66.0903 2.11252 66.0903 1.97709V0.133781Z"
          fill="white"
        />
        <path
          d="M43.4961 3.47456H41.5474C41.412 3.47456 41.2991 3.58742 41.2991 3.72285V10.7726C41.2991 10.9531 41.2841 11.0208 41.2766 11.0434C40.6972 11.5701 40.0502 11.9764 38.9367 11.9764C37.6501 11.9764 37.6877 10.7199 37.6877 10.7199V9.65153V3.71532C37.6877 3.5799 37.5824 3.46704 37.4394 3.46704H35.4907C35.3553 3.46704 35.2424 3.5799 35.2424 3.71532V9.7042C35.2199 10.261 35.1898 13.9024 38.41 13.9024C39.4558 13.9024 40.5392 13.3682 41.1637 12.9243C41.2239 12.8943 41.2916 12.8717 41.2991 12.962V13.4585C41.2991 13.594 41.412 13.7068 41.5474 13.7068H43.4961C43.6315 13.7068 43.7444 13.594 43.7444 13.4585V3.71532C43.7444 3.5799 43.6315 3.46704 43.4961 3.46704"
          fill="white"
        />
        <path
          d="M70.0025 7.77859C70.0853 7.20678 70.2433 6.69517 70.469 6.33403C70.8452 5.76223 71.2289 5.44624 72.2522 5.41614C72.8164 5.41614 73.2904 5.56661 73.6742 5.97289C73.9676 6.28137 74.261 6.82307 74.3814 7.77106H70.0025V7.77859ZM76.3 9.53161C76.3 9.53161 76.4279 9.53161 76.4806 9.48647C76.5332 9.4338 76.5107 9.34352 76.5107 9.34352V8.80181C76.5107 6.88327 76.0367 5.49138 75.1865 4.58101C74.3363 3.66312 73.2002 3.36217 72.2597 3.36969C70.6345 3.3396 69.3404 4.16721 68.7009 5.28071C68.0463 6.3867 67.8808 7.66573 67.8733 8.87705C67.8582 10.9235 68.588 12.3605 69.6339 13.143C70.612 13.8728 71.3944 13.9179 72.1092 13.9255C72.1619 13.9255 72.207 13.9255 72.2597 13.9255C72.4177 13.9255 72.5832 13.9179 72.7412 13.9104C73.7795 13.8653 74.8178 13.7449 75.8486 13.5493C75.9614 13.5267 76.0517 13.4214 76.0517 13.3236C76.0592 12.827 76.0668 12.3304 76.0743 11.8414C76.0743 11.7361 75.984 11.6759 75.8787 11.6984C74.8253 11.9016 73.7645 12.0069 72.6961 12.0445C72.6509 12.0445 72.6133 12.0445 72.5682 12.0445C72.0565 12.0445 71.3568 11.8941 70.8828 11.5179C70.3862 11.1266 70.0853 10.5473 70.01 9.53914H76.3V9.53161Z"
          fill="white"
        />
        <path
          d="M26.9817 8.06428L28.0952 3.10615C28.1629 2.85787 28.336 2.32369 28.6595 2.32369C29.0733 2.32369 29.0959 2.6773 29.2539 3.37701C29.3241 3.68799 29.3241 3.68799 29.2539 3.37701L30.3072 8.06428H26.9817ZM33.9563 13.4738L30.9543 1.48103C30.9543 1.48103 30.9317 1.43589 30.9242 1.40579C30.7135 0.83399 30.1041 0.382568 29.5097 0.382568H27.7792C27.1322 0.382568 26.4776 0.89418 26.3196 1.52617L25.665 4.1369C25.665 4.1369 25.665 4.15947 25.665 4.17452L23.3401 13.4663C23.3025 13.6168 23.3853 13.7372 23.5207 13.7372H25.4694C25.6048 13.7372 25.7403 13.6168 25.7779 13.4663L26.5829 9.89254H30.7286L31.5261 13.4663C31.5637 13.6168 31.6992 13.7372 31.8346 13.7372H33.7833C33.9187 13.7372 34.0015 13.6168 33.9638 13.4663"
          fill="white"
        />
        <path
          d="M19.1412 13.6091C19.1412 13.7821 18.9982 13.9251 18.8252 13.9251H0.278893C0.0983201 13.9251 -0.0371094 13.7821 -0.0371094 13.6091V12.8116C-0.0371094 12.631 0.105844 12.488 0.278893 12.488H18.8252C18.9982 12.488 19.1412 12.631 19.1412 12.8116V13.6091Z"
          fill="#FFD11F"
        />
        <path
          d="M19.1412 10.8933C19.1412 11.0663 18.9982 11.2168 18.8252 11.2168H0.278893C0.0983201 11.2168 -0.0371094 11.0738 -0.0371094 10.8933V10.0882C-0.0371094 9.91517 0.105844 9.77222 0.278893 9.77222H18.8252C18.9982 9.77222 19.1412 9.91517 19.1412 10.0882V10.8933Z"
          fill="#FFD11F"
        />
        <path
          d="M16.4255 7.08569C16.4255 7.14588 16.3728 7.19855 16.3126 7.19855H2.80731C2.80731 7.19855 2.79978 7.19855 2.79226 7.19855C2.73207 7.19855 2.68692 7.14588 2.68692 7.08569C2.68692 7.04807 2.7095 7.01045 2.73959 6.9954L9.29287 1.57833C9.29287 1.57833 9.45087 1.43538 9.57878 1.43538C9.69163 1.43538 9.84964 1.58586 9.84964 1.58586L16.3728 7.00293C16.3728 7.00293 16.418 7.05559 16.418 7.08569M18.9008 7.34902L10.3462 0.246636C10.3462 0.246636 9.96249 -0.114502 9.57878 -0.114502C9.19506 -0.114502 8.79629 0.25416 8.79629 0.25416L0.196529 7.34902C0.0460522 7.4694 -0.0517578 7.65749 -0.0517578 7.86063C-0.0517578 8.22929 0.25672 8.53024 0.632913 8.53024H18.4419C18.4419 8.53024 18.4419 8.53024 18.4494 8.53024C18.8256 8.53024 19.1341 8.22929 19.1341 7.86063C19.1341 7.65749 19.0363 7.47692 18.8858 7.34902"
          fill="white"
        />
        <path d="M84.1174 -2.55884V16.3783" stroke="white" stroke-width="0.0332179" stroke-miterlimit="10" />
        <path
          d="M92.6262 13.7593V0.397217H98.6829C101.339 0.397217 103.182 1.47311 103.182 3.84308V4.03117C103.182 5.15973 102.58 6.198 101.452 6.76228C102.904 7.28894 103.731 8.44007 103.731 9.847V10.0125C103.731 12.2922 101.813 13.7593 99.0441 13.7593H92.6262ZM95.711 5.81429H98.2917C99.4955 5.81429 100.045 5.37791 100.045 4.4224V4.23431C100.045 3.29385 99.4428 2.89509 98.2917 2.89509H95.711V5.81429ZM95.711 11.2539H98.7431C99.9244 11.2539 100.586 10.6897 100.586 9.80186V9.63634C100.586 8.71092 99.9846 8.18426 98.7582 8.18426H95.711V11.2539Z"
          fill="white"
        />
        <path
          d="M105.041 13.7596V4.03149H107.923L107.983 5.93499C108.435 4.80643 109.36 3.86597 110.827 3.86597C111.038 3.86597 111.263 3.88101 111.429 3.91863V6.80021C111.218 6.78517 110.917 6.7626 110.639 6.7626C108.886 6.7626 108.058 7.62782 108.058 9.23037V13.7672H105.049L105.041 13.7596Z"
          fill="white"
        />
        <path
          d="M115.635 2.8658H112.513V-0.16626H115.635V2.8658ZM115.582 4.03197V13.7601H112.573V4.03197H115.582Z"
          fill="white"
        />
        <path
          d="M116.936 8.97505V8.78696C116.936 5.943 118.478 3.78369 121.097 3.78369C122.489 3.78369 123.489 4.44578 124.031 5.311V-0.16626H127.063V13.7601H124.257L124.166 12.1952C123.768 13.098 122.752 14.0009 121.195 14.0009C118.561 14.0009 116.944 11.8717 116.944 8.97505H116.936ZM124.121 8.97505V8.78696C124.121 6.98127 123.444 6.0408 122.052 6.0408C120.66 6.0408 119.983 6.98127 119.983 8.78696V8.97505C119.983 10.7657 120.66 11.7212 122.052 11.7212C123.444 11.7212 124.121 10.7582 124.121 8.97505Z"
          fill="white"
        />
        <path
          d="M128.719 14.1132H131.803C131.916 14.7753 132.443 15.1289 133.557 15.1289C134.896 15.1289 135.513 14.4894 135.513 13.3759V11.9238C135.001 12.8267 133.985 13.4887 132.631 13.4887C129.998 13.4887 128.418 11.3445 128.418 8.72624V8.53814C128.418 5.91989 129.998 3.77563 132.631 3.77563C134.173 3.77563 135.227 4.66343 135.641 5.56628L135.731 4.02392H138.537V12.9997C138.537 15.7308 136.619 17.1979 133.421 17.1979C130.524 17.1979 128.869 15.9565 128.719 14.1132ZM135.603 8.71119V8.53814C135.603 6.97321 134.926 6.03275 133.534 6.03275C132.142 6.03275 131.465 6.97321 131.465 8.53814V8.71119C131.465 10.2761 132.142 11.2166 133.534 11.2166C134.926 11.2166 135.603 10.2761 135.603 8.71119Z"
          fill="white"
        />
        <path
          d="M139.891 8.97432V8.78623C139.891 5.79179 141.908 3.78296 145.03 3.78296C148.416 3.78296 150.109 6.15293 149.905 9.57622H142.886C143.021 11.0659 143.713 11.7807 145.015 11.7807C146.091 11.7807 146.693 11.254 146.896 10.6295H149.853C149.386 12.6835 147.633 14.0002 145.037 14.0002C141.855 14.0002 139.899 12.0214 139.899 8.97432H139.891ZM146.873 7.83072C146.798 6.71721 146.196 6.00245 144.992 6.00245C143.788 6.00245 143.126 6.56673 142.923 7.83072H146.873Z"
          fill="white"
        />
        <path
          d="M83.4853 27.2791H83.1543L83.9894 23.3367H84.3205L84.2152 23.8333H84.2227C84.2904 23.743 84.3656 23.6602 84.4559 23.585C84.5462 23.5098 84.644 23.4496 84.7418 23.4044C84.8396 23.3593 84.9374 23.3217 85.0428 23.2991C85.1406 23.2765 85.2384 23.2615 85.3287 23.2615C85.5544 23.2615 85.7425 23.2991 85.893 23.3743C86.0359 23.4496 86.1488 23.5549 86.224 23.6903C86.2993 23.8258 86.3369 23.9838 86.3444 24.1643C86.3519 24.3449 86.3369 24.5405 86.2917 24.7512C86.2466 24.9468 86.1864 25.1349 86.0961 25.3154C86.0058 25.496 85.9005 25.654 85.7651 25.7894C85.6296 25.9249 85.4792 26.0377 85.2986 26.1205C85.1256 26.2032 84.9299 26.2409 84.7117 26.2409C84.5086 26.2409 84.328 26.1957 84.1625 26.1054C83.997 26.0152 83.8841 25.8872 83.8164 25.7067L83.4853 27.2716V27.2791ZM84.0195 24.7662C83.9895 24.9242 83.9744 25.0747 83.9894 25.2252C84.0045 25.3681 84.0421 25.496 84.1023 25.6013C84.1625 25.7067 84.2453 25.797 84.3506 25.8572C84.4559 25.9173 84.5838 25.955 84.7268 25.955C84.8923 25.955 85.0503 25.9249 85.1857 25.8572C85.3287 25.7894 85.4491 25.6992 85.5544 25.5788C85.6597 25.4584 85.7425 25.3305 85.8177 25.1725C85.8855 25.0145 85.9381 24.849 85.9682 24.6759C86.0435 24.3223 86.0058 24.0439 85.8704 23.8558C85.735 23.6678 85.5243 23.5699 85.2459 23.5699C85.0955 23.5699 84.9525 23.6 84.8171 23.6602C84.6816 23.7204 84.5688 23.8032 84.4635 23.916C84.3581 24.0289 84.2678 24.1493 84.2001 24.2997C84.1249 24.4502 84.0722 24.6082 84.0346 24.7737L84.0195 24.7662Z"
          fill="white"
        />
        <path
          d="M87.7972 26.2487C87.6166 26.2487 87.4511 26.2111 87.3082 26.1509C87.1652 26.0907 87.0448 25.9929 86.9545 25.8725C86.8642 25.7521 86.8041 25.5941 86.774 25.406C86.7439 25.2179 86.7589 25.0073 86.8041 24.759C86.8492 24.5483 86.9169 24.3602 87.0072 24.1797C87.0975 23.9991 87.2179 23.8411 87.3533 23.7057C87.4887 23.5702 87.6467 23.4649 87.8273 23.3897C88.0079 23.3144 88.2035 23.2693 88.4217 23.2693C88.6399 23.2693 88.828 23.3069 88.9785 23.3897C89.1289 23.4649 89.2418 23.5702 89.317 23.7057C89.3998 23.8411 89.4449 23.9991 89.46 24.1797C89.475 24.3602 89.46 24.5558 89.4148 24.7665C89.3697 24.9922 89.2945 25.1954 89.1891 25.3759C89.0913 25.5565 88.9634 25.7145 88.8204 25.8424C88.6775 25.9703 88.5195 26.0756 88.3465 26.1433C88.1734 26.2111 87.9853 26.2487 87.7897 26.2487H87.7972ZM89.0763 24.7515C89.1063 24.5859 89.1214 24.4279 89.1214 24.285C89.1214 24.142 89.0913 24.0141 89.0386 23.9088C88.986 23.8035 88.9032 23.7132 88.7979 23.653C88.6925 23.5928 88.5496 23.5627 88.3765 23.5627C88.2035 23.5627 88.053 23.5928 87.9176 23.6605C87.7822 23.7282 87.6618 23.8185 87.564 23.9314C87.4586 24.0442 87.3759 24.1721 87.3157 24.3151C87.248 24.458 87.2028 24.6085 87.1652 24.759C87.1276 24.932 87.1201 25.0975 87.1276 25.2405C87.1426 25.391 87.1727 25.5114 87.2329 25.6167C87.2931 25.722 87.3759 25.8048 87.4812 25.865C87.5865 25.9252 87.722 25.9553 87.88 25.9553C88.053 25.9553 88.2035 25.9252 88.3389 25.8574C88.4743 25.7897 88.5947 25.6994 88.6925 25.5866C88.7904 25.4737 88.8731 25.3458 88.9408 25.2029C89.0085 25.0599 89.0537 24.917 89.0913 24.759L89.0763 24.7515Z"
          fill="white"
        />
        <path
          d="M92.2051 25.729L93.454 23.3364H93.7851L92.2653 26.1653H91.9192L91.8063 23.7878H91.7988L90.6702 26.1653H90.279L90.0156 23.3364H90.3467L90.5649 25.7515L91.7311 23.3364H92.0997L92.2126 25.729H92.2051Z"
          fill="white"
        />
        <path
          d="M94.1462 24.8342C94.1161 24.9847 94.1011 25.1276 94.1162 25.2706C94.1237 25.406 94.1613 25.5264 94.2215 25.6242C94.2817 25.722 94.3644 25.8048 94.4698 25.865C94.5751 25.9252 94.7105 25.9553 94.8685 25.9553C95.0867 25.9553 95.2823 25.9026 95.4554 25.7897C95.6284 25.6769 95.7639 25.5189 95.8617 25.3082H96.2304C96.1626 25.4436 96.0799 25.5715 95.9896 25.6844C95.8993 25.7973 95.794 25.9026 95.6811 25.9853C95.5683 26.0681 95.4328 26.1358 95.2899 26.181C95.1469 26.2261 94.9814 26.2487 94.8008 26.2487C94.5751 26.2487 94.387 26.2111 94.2441 26.1358C94.0936 26.0606 93.9807 25.9553 93.9055 25.8198C93.8302 25.6844 93.7851 25.5339 93.77 25.3534C93.7625 25.1728 93.7701 24.9772 93.8227 24.774C93.8679 24.5634 93.9356 24.3753 94.0334 24.1872C94.1312 23.9991 94.2516 23.8486 94.3945 23.7132C94.5375 23.5778 94.6955 23.4724 94.8685 23.3897C95.0416 23.3144 95.2372 23.2693 95.4403 23.2693C95.8316 23.2693 96.11 23.4047 96.2755 23.668C96.441 23.9389 96.4711 24.3226 96.3583 24.8342H94.1613H94.1462ZM96.0498 24.5558C96.0799 24.4204 96.0874 24.285 96.0723 24.1646C96.0573 24.0442 96.0272 23.9389 95.9745 23.8486C95.9219 23.7583 95.8391 23.6906 95.7413 23.6379C95.636 23.5853 95.5156 23.5552 95.3726 23.5552C95.2297 23.5552 95.0943 23.5853 94.9739 23.6379C94.8535 23.6906 94.7406 23.7659 94.6428 23.8561C94.545 23.9464 94.4622 24.0518 94.387 24.1721C94.3118 24.2925 94.2591 24.4204 94.214 24.5558H96.0573H96.0498Z"
          fill="white"
        />
        <path
          d="M97.0356 26.1653H96.7046L97.3065 23.3364H97.6376L97.5247 23.8631H97.5322C97.6676 23.6374 97.8181 23.4794 97.9837 23.3891C98.1492 23.2988 98.3448 23.2537 98.5856 23.2537L98.5103 23.6073C98.3297 23.6073 98.1717 23.6298 98.0363 23.6976C97.9009 23.7578 97.788 23.8405 97.6977 23.9458C97.6075 24.0512 97.5247 24.1791 97.472 24.322C97.4118 24.465 97.3667 24.6155 97.3291 24.7735L97.0356 26.1578V26.1653Z"
          fill="white"
        />
        <path
          d="M98.9995 24.8342C98.9694 24.9847 98.9544 25.1276 98.9694 25.2706C98.9769 25.406 99.0146 25.5264 99.0748 25.6242C99.1349 25.722 99.2177 25.8048 99.323 25.865C99.4284 25.9252 99.5638 25.9553 99.7218 25.9553C99.94 25.9553 100.136 25.9026 100.309 25.7897C100.482 25.6769 100.617 25.5189 100.715 25.3082H101.084C101.016 25.4436 100.933 25.5715 100.843 25.6844C100.753 25.7973 100.647 25.9026 100.534 25.9853C100.422 26.0681 100.286 26.1358 100.143 26.181C100 26.2261 99.8347 26.2487 99.6541 26.2487C99.4284 26.2487 99.2403 26.2111 99.0973 26.1358C98.9468 26.0606 98.834 25.9553 98.7588 25.8198C98.6835 25.6844 98.6384 25.5339 98.6233 25.3534C98.6158 25.1728 98.6233 24.9772 98.676 24.774C98.7211 24.5634 98.7888 24.3753 98.8867 24.1872C98.9845 23.9991 99.1048 23.8486 99.2478 23.7132C99.3908 23.5778 99.5488 23.4724 99.7218 23.3897C99.8949 23.3144 100.09 23.2693 100.294 23.2693C100.685 23.2693 100.963 23.4047 101.129 23.668C101.294 23.9389 101.324 24.3226 101.212 24.8342H99.0146H98.9995ZM100.903 24.5558C100.933 24.4204 100.941 24.285 100.926 24.1646C100.911 24.0442 100.88 23.9389 100.828 23.8486C100.775 23.7583 100.692 23.6906 100.595 23.6379C100.489 23.5853 100.369 23.5552 100.226 23.5552C100.083 23.5552 99.9475 23.5853 99.8271 23.6379C99.7068 23.6906 99.5939 23.7659 99.4961 23.8561C99.3983 23.9464 99.3155 24.0518 99.2403 24.1721C99.165 24.2925 99.1124 24.4204 99.0672 24.5558H100.911H100.903Z"
          fill="white"
        />
        <path
          d="M104.567 22.2383H104.898L104.063 26.1657H103.732L103.837 25.6691H103.83C103.762 25.7669 103.687 25.8497 103.596 25.9174C103.506 25.9851 103.408 26.0453 103.311 26.0979C103.213 26.1506 103.115 26.1807 103.017 26.2033C102.919 26.2258 102.821 26.2409 102.731 26.2409C102.505 26.2409 102.317 26.2033 102.167 26.128C102.024 26.0528 101.911 25.9475 101.836 25.812C101.761 25.6766 101.723 25.5186 101.715 25.3381C101.708 25.1575 101.723 24.9619 101.768 24.7512C101.813 24.5556 101.873 24.3675 101.964 24.1869C102.054 24.0064 102.159 23.8484 102.295 23.7129C102.43 23.5775 102.581 23.4646 102.761 23.3819C102.934 23.2991 103.13 23.2615 103.348 23.2615C103.551 23.2615 103.732 23.3066 103.897 23.3969C104.063 23.4872 104.176 23.6151 104.243 23.7957L104.575 22.2383H104.567ZM104.033 24.7437C104.063 24.5857 104.078 24.4352 104.063 24.2847C104.048 24.1418 104.018 24.0139 103.958 23.9085C103.897 23.8032 103.815 23.7129 103.717 23.6527C103.611 23.5925 103.484 23.5549 103.341 23.5549C103.168 23.5549 103.017 23.585 102.874 23.6527C102.739 23.7205 102.611 23.8107 102.505 23.9311C102.4 24.044 102.31 24.1794 102.242 24.3374C102.174 24.4954 102.122 24.6609 102.092 24.834C102.054 25.0145 102.047 25.1725 102.069 25.308C102.092 25.4434 102.129 25.5562 102.197 25.654C102.265 25.7519 102.347 25.8196 102.46 25.8722C102.566 25.9174 102.694 25.9475 102.829 25.9475C102.979 25.9475 103.122 25.9174 103.258 25.8572C103.393 25.797 103.506 25.7142 103.611 25.6014C103.717 25.4885 103.8 25.3681 103.875 25.2177C103.943 25.0672 104.003 24.9092 104.033 24.7437Z"
          fill="white"
        />
        <path
          d="M106.764 26.1657H106.433L107.268 22.2383H107.599L107.268 23.7957C107.411 23.6226 107.584 23.4872 107.787 23.3969C107.991 23.3066 108.194 23.2615 108.389 23.2615C108.608 23.2615 108.781 23.2991 108.923 23.3819C109.066 23.4646 109.172 23.57 109.247 23.7129C109.322 23.8559 109.367 24.0064 109.375 24.1869C109.39 24.3675 109.375 24.5556 109.33 24.7512C109.285 24.9619 109.224 25.15 109.134 25.3381C109.044 25.5186 108.939 25.6766 108.803 25.812C108.675 25.9475 108.517 26.0453 108.344 26.128C108.171 26.2033 107.968 26.2409 107.735 26.2409C107.644 26.2409 107.554 26.2258 107.464 26.2033C107.374 26.1807 107.291 26.1431 107.216 26.0979C107.14 26.0528 107.065 25.9926 107.005 25.9174C106.945 25.8497 106.9 25.7669 106.869 25.6691H106.862L106.757 26.1657H106.764ZM107.065 24.7437C107.027 24.9167 107.012 25.0747 107.027 25.2177C107.043 25.3681 107.073 25.496 107.133 25.6014C107.193 25.7067 107.276 25.797 107.381 25.8572C107.486 25.9174 107.622 25.9475 107.772 25.9475C107.908 25.9475 108.043 25.9249 108.171 25.8722C108.299 25.8196 108.412 25.7519 108.517 25.654C108.623 25.5562 108.713 25.4434 108.796 25.308C108.878 25.1725 108.931 25.0145 108.976 24.834C109.021 24.6534 109.044 24.4879 109.036 24.3374C109.029 24.1869 109.006 24.044 108.946 23.9311C108.893 23.8183 108.811 23.7205 108.698 23.6527C108.585 23.585 108.45 23.5549 108.284 23.5549C108.134 23.5549 107.998 23.585 107.863 23.6527C107.735 23.7205 107.614 23.8032 107.501 23.9085C107.389 24.0139 107.306 24.1418 107.231 24.2847C107.155 24.4277 107.103 24.5782 107.073 24.7437H107.065Z"
          fill="white"
        />
        <path
          d="M109.548 26.9328C109.586 26.9328 109.631 26.9478 109.676 26.9553C109.721 26.9629 109.766 26.9704 109.819 26.9704C109.909 26.9704 109.992 26.9403 110.06 26.8801C110.127 26.8199 110.195 26.7522 110.248 26.6694C110.3 26.5867 110.353 26.5039 110.398 26.4136C110.443 26.3233 110.489 26.2481 110.534 26.1879L110.045 23.3364H110.413L110.805 25.7666L112.227 23.3364H112.58L110.932 26.1277C110.827 26.3083 110.729 26.4663 110.647 26.6092C110.556 26.7522 110.473 26.8726 110.383 26.9704C110.293 27.0682 110.203 27.1434 110.112 27.1961C110.015 27.2488 109.917 27.2788 109.804 27.2788C109.744 27.2788 109.691 27.2789 109.638 27.2713C109.586 27.2638 109.541 27.2563 109.495 27.2412L109.563 26.9328H109.548Z"
          fill="white"
        />
        <path
          d="M115.823 20.6958H118.013C118.569 20.6958 119.013 20.8312 119.344 21.1021C119.683 21.3729 119.849 21.7416 119.849 22.2081C119.849 22.336 119.826 22.4639 119.796 22.5993C119.713 22.8626 119.45 23.2539 119.028 23.4344C119.42 23.5623 119.698 23.758 119.864 24.0138C120.029 24.2696 120.112 24.5404 120.112 24.8188C120.112 25.7818 119.405 26.4213 118.08 26.4213H115.823V20.7033V20.6958ZM116.719 23.126H117.84C118.577 23.126 118.953 22.7799 118.953 22.3059C118.953 21.8319 118.622 21.5159 117.892 21.5159H116.719V23.126ZM116.719 25.6088H118.103C118.833 25.6088 119.224 25.2627 119.224 24.7511C119.224 24.2395 118.84 23.916 118.05 23.916H116.726V25.6163L116.719 25.6088Z"
          fill="white"
        />
        <path
          d="M122.918 23.3972C122.85 23.3822 122.767 23.3747 122.67 23.3747C122.007 23.3747 121.654 23.7584 121.654 24.443V26.4293H120.789V22.5245H121.631V23.1489C121.872 22.7126 122.233 22.4944 122.707 22.4944C122.805 22.4944 122.865 22.4944 122.918 22.517V23.4048V23.3972Z"
          fill="white"
        />
        <path
          d="M123.686 20.8544C123.912 20.6211 124.265 20.6211 124.491 20.8544C124.717 21.0801 124.717 21.4337 124.491 21.6594C124.265 21.8851 123.912 21.8851 123.686 21.6594C123.46 21.4337 123.46 21.0876 123.686 20.8544ZM124.529 26.4294H123.663V22.5246H124.529V26.4294Z"
          fill="white"
        />
        <path
          d="M125.755 23.0586C126.109 22.6448 126.583 22.4417 127.169 22.4417C127.38 22.4417 127.606 22.4868 127.854 22.5997C128.11 22.705 128.298 22.8555 128.433 23.0661V20.4705H129.299V26.4217H128.456V25.8123C128.313 26.038 128.117 26.2035 127.847 26.3164C127.583 26.4292 127.35 26.4744 127.147 26.4744C126.605 26.4744 126.139 26.2788 125.77 25.8725C125.409 25.4662 125.228 24.9922 125.228 24.458C125.228 23.9238 125.401 23.4649 125.762 23.0511M126.432 23.5928C126.221 23.8411 126.109 24.127 126.109 24.4731C126.109 24.8192 126.221 25.1051 126.432 25.3533C126.65 25.5866 126.936 25.6994 127.275 25.6994C127.613 25.6994 127.907 25.5791 128.11 25.3533C128.328 25.1051 128.441 24.8192 128.441 24.4731C128.441 24.127 128.328 23.8411 128.11 23.5928C127.892 23.352 127.613 23.2392 127.275 23.2392C126.929 23.2392 126.643 23.352 126.432 23.5928Z"
          fill="white"
        />
        <path
          d="M130.458 25.8579C130.104 25.4667 129.924 25.0002 129.924 24.451C129.924 23.9017 130.097 23.4729 130.45 23.0591C130.804 22.6453 131.278 22.4421 131.857 22.4421C132.068 22.4421 132.294 22.4948 132.542 22.6077C132.79 22.7205 132.986 22.8785 133.129 23.0967V22.5023H133.971V26.3545C133.971 26.9714 133.783 27.4605 133.407 27.8141C133.038 28.1677 132.549 28.3483 131.932 28.3483C130.984 28.3483 130.322 27.957 129.969 27.167L130.699 26.7457C130.969 27.2874 131.376 27.5733 131.925 27.5733C132.602 27.5733 133.106 27.1595 133.106 26.377V25.7601C132.963 25.9858 132.768 26.1438 132.512 26.2567C132.256 26.3695 132.03 26.4147 131.827 26.4147C131.278 26.4372 130.811 26.2341 130.458 25.8429M132.798 23.5857C132.587 23.3525 132.301 23.2397 131.963 23.2397C131.624 23.2397 131.331 23.36 131.127 23.5857C130.917 23.8115 130.804 24.1049 130.804 24.4434C130.804 24.782 130.917 25.083 131.127 25.3237C131.346 25.557 131.624 25.6698 131.963 25.6698C132.301 25.6698 132.587 25.5494 132.79 25.3237C133.008 25.083 133.121 24.7895 133.121 24.4434C133.121 24.0974 133.008 23.8115 132.798 23.5857Z"
          fill="white"
        />
        <path d="M136.01 22.5249H135.145V26.4297H136.01V22.5249Z" fill="#36DB77" />
        <path
          d="M138.268 23.3074V25.0303C138.268 25.4968 138.494 25.6774 138.938 25.6774C139.028 25.6774 139.118 25.6774 139.216 25.6473V26.3846C139.073 26.4373 138.915 26.4674 138.749 26.4674C137.899 26.4674 137.395 26.016 137.395 25.1658V23.2924H136.673V22.5099H137.395V21.2986H138.26V22.5099H139.223V23.2924H138.268V23.3074Z"
          fill="#36DB77"
        />
        <path
          d="M133.987 21.9231C133.987 21.5995 134.243 21.3437 134.566 21.3437C134.89 21.3437 135.146 21.5995 135.146 21.9231H136.011C136.011 21.1256 135.364 20.4785 134.566 20.4785C133.769 20.4785 133.122 21.1256 133.122 21.9231H133.987Z"
          fill="#36DB77"
        />
      </g>
      <defs>
        <clipPath id="clip0_969_5336">
          <rect width="150" height="28.3784" fill="white" />
        </clipPath>
      </defs>
    </symbol>
    <symbol id="finsure_logo" viewBox="0 0 234 90" preserveAspectRatio="xMinYMid meet" fill="none">
      <circle cx="195.314" cy="37.7736" r="37.1379" fill="white" />
      <path
        d="M0 25.0234C0 24.6902 0.266584 24.3905 0.632845 24.3905H13.7601C14.1265 24.3905 14.3931 24.6902 14.3931 25.0234V25.9898C14.3931 26.3229 14.1265 26.6226 13.7601 26.6226H2.56555V35.7513H12.1274C12.4606 35.7513 12.7603 36.0513 12.7603 36.3845V37.3505C12.7603 37.6837 12.4606 37.9837 12.1274 37.9837H2.56555V47.0792C2.56555 47.4124 2.26553 47.7124 1.93233 47.7124H0.632845C0.266584 47.7124 0 47.4124 0 47.0792V25.0234Z"
        fill="white"
      />
      <path
        d="M20.6221 25.0234C20.6221 24.6902 20.9221 24.3905 21.2549 24.3905H22.5876C22.9212 24.3905 23.2208 24.6902 23.2208 25.0234V47.0792C23.2208 47.4124 22.9212 47.7124 22.5876 47.7124H21.2549C20.9221 47.7124 20.6221 47.4124 20.6221 47.0792V25.0234Z"
        fill="white"
      />
      <path
        d="M31.6831 24.6571C31.6831 24.324 31.9828 24.0574 32.3163 24.0574H33.1491L48.1754 42.7815C48.2085 42.7815 48.2085 42.7815 48.2417 42.7815V25.0235C48.2417 24.6903 48.5082 24.3906 48.8749 24.3906H50.0412C50.374 24.3906 50.674 24.6903 50.674 25.0235V47.4459C50.674 47.7791 50.374 48.0457 50.0412 48.0457H49.4411L34.1486 28.9549H34.1151V47.0793C34.1151 47.4125 33.8486 47.7125 33.4822 47.7125H32.3163C31.9828 47.7125 31.6831 47.4125 31.6831 47.0793V24.6571Z"
        fill="white"
      />
      <path
        d="M57.8687 44.6138L58.1684 44.214C58.4018 43.9475 58.6352 43.8477 58.9017 44.0807C59.2346 44.3807 61.7004 46.6463 65.0653 46.6463C68.0973 46.6463 70.6626 44.6138 70.6626 42.1818C70.6626 39.2164 68.2306 37.8837 64.199 36.5178C60.3342 35.1517 57.7686 33.7858 57.7686 29.9545C57.7686 27.4558 59.7677 24.0574 64.9652 24.0574C68.2638 24.0574 70.6958 25.7565 70.6958 25.7565C70.829 25.8566 71.0624 26.0896 70.829 26.4563C70.7293 26.5896 70.6295 26.756 70.5625 26.8892C70.3629 27.1558 70.1627 27.2559 69.8298 27.056C69.7297 26.9894 67.4973 25.4899 64.932 25.4899C60.8338 25.4899 59.3015 28.022 59.3015 29.9213C59.3015 32.7528 61.467 33.9857 64.8319 35.085C69.3966 36.6511 72.295 38.2503 72.295 42.1152C72.295 45.4469 68.8635 48.0457 65.0321 48.0457C61.0672 48.0457 58.4018 45.7134 57.9688 45.3136C57.7686 45.1469 57.6022 44.9805 57.8687 44.6138Z"
        fill="white"
      />
      <path
        d="M78.7578 24.8236C78.7578 24.5905 78.9577 24.3906 79.1911 24.3906H79.8906C80.124 24.3906 80.3236 24.5905 80.3236 24.8236V39.0499C80.3236 43.3477 83.0224 46.5131 87.4535 46.5131C91.9177 46.5131 94.6501 43.3812 94.6501 39.0831V24.8236C94.6501 24.557 94.7833 24.3906 95.1162 24.3906H95.7825C96.0159 24.3906 96.2158 24.5905 96.2158 24.8236V39.2164C96.2158 44.3141 92.7508 48.0457 87.4535 48.0457C82.1894 48.0457 78.7578 44.3141 78.7578 39.2164V24.8236Z"
        fill="white"
      />
      <path
        d="M113.307 37.3174C116.505 37.3174 119.204 34.8184 119.204 31.5201C119.204 28.3551 116.505 25.9231 113.273 25.9231H106.276V37.3174H113.307ZM104.677 24.8235C104.677 24.5904 104.844 24.3905 105.11 24.3905H113.373C117.438 24.3905 120.803 27.4557 120.803 31.5201C120.803 34.885 118.471 37.5839 115.306 38.4833L120.169 47.1127C120.336 47.3792 120.269 47.7124 119.936 47.7124H118.904C118.671 47.7124 118.537 47.6123 118.437 47.4124L113.606 38.6832C113.173 38.7167 112.807 38.7167 112.374 38.7167H106.243V47.2791C106.243 47.5125 106.043 47.7124 105.71 47.7124H105.11C104.877 47.7124 104.677 47.5125 104.677 47.2791V24.8235Z"
        fill="white"
      />
      <path
        d="M127.998 24.8235C127.998 24.5904 128.198 24.3905 128.431 24.3905H141.791C142.024 24.3905 142.224 24.5904 142.224 24.8235V25.39C142.224 25.6231 142.024 25.823 141.791 25.823H129.597V35.0183H140.159C140.392 35.0183 140.592 35.2182 140.592 35.4516V36.0178C140.592 36.2512 140.392 36.4511 140.159 36.4511H129.597V46.3131H141.791C142.024 46.3131 142.224 46.513 142.224 46.746V47.2791C142.224 47.5125 142.024 47.7124 141.791 47.7124H128.431C128.198 47.7124 127.998 47.5125 127.998 47.2791V24.8235Z"
        fill="white"
      />
      <path
        d="M38.2766 54.9781C38.2766 54.8893 38.3527 54.8129 38.4421 54.8129H38.7219C38.7983 54.8129 38.8747 54.8893 38.8747 54.9781V63.1826H42.9322C43.0847 63.1826 43.0974 63.2591 43.0974 63.3478V63.577C43.0974 63.6658 43.0209 63.717 42.9322 63.717H38.4421C38.3527 63.717 38.2766 63.6406 38.2766 63.5515V54.9781Z"
        fill="white"
      />
      <path
        d="M54.7896 63.2847C57.0157 63.2847 58.8218 61.5036 58.8218 59.2774C58.8218 57.0517 57.0157 55.2453 54.7896 55.2453C52.5635 55.2453 50.7701 57.0517 50.7701 59.2774C50.7701 61.5036 52.5635 63.2847 54.7896 63.2847ZM54.7896 54.6856C57.3464 54.6856 59.3814 56.7336 59.3814 59.2774C59.3814 61.8345 57.3464 63.8442 54.7896 63.8442C52.2458 63.8442 50.2104 61.8345 50.2104 59.2774C50.2104 56.7336 52.2458 54.6856 54.7896 54.6856Z"
        fill="white"
      />
      <path
        d="M72.8931 60.7658L70.7179 55.6397H70.6926L68.4791 60.7658H72.8931ZM66.6092 63.5644L70.5271 54.7112C70.5524 54.66 70.6162 54.6221 70.6796 54.6221H70.7179C70.7817 54.6221 70.8451 54.6348 70.8833 54.7112L74.763 63.5644C74.7883 63.6406 74.7883 63.717 74.6484 63.717H74.3177C74.2287 63.717 74.1649 63.6532 74.1396 63.6023L73.1091 61.2619H68.2502L67.2326 63.6023C67.2074 63.6532 67.1436 63.717 67.0545 63.717H66.6986C66.6092 63.717 66.571 63.6658 66.6092 63.5644Z"
        fill="white"
      />
      <path
        d="M82.6772 54.8511C82.6772 54.7494 82.7663 54.6856 82.8677 54.6856H83.0843L89.1898 62.6357C89.2024 62.6357 89.2024 62.6357 89.2024 62.6357V54.9781C89.2024 54.8893 89.2788 54.8129 89.3676 54.8129H89.6221C89.7112 54.8129 89.7876 54.8893 89.7876 54.9781V63.6788C89.7876 63.7934 89.6859 63.8442 89.5842 63.8442H89.4187C89.4058 63.8442 89.3044 63.8061 83.2624 55.8178H83.2495V63.5515C83.2495 63.6406 83.1731 63.7171 83.0843 63.7171H82.8424C82.7537 63.7171 82.6772 63.6406 82.6772 63.5515V54.8511Z"
        fill="white"
      />
      <path
        d="M98.4399 62.5336L98.5545 62.3814C98.6432 62.2795 98.7323 62.2413 98.8343 62.3304C98.9612 62.445 99.9027 63.3096 101.187 63.3096C102.345 63.3096 103.324 62.5336 103.324 61.6056C103.324 60.4734 102.396 59.9646 100.857 59.4432C99.3813 58.9215 98.4016 58.4001 98.4016 56.9373C98.4016 55.9833 99.1646 54.6856 101.149 54.6856C102.408 54.6856 103.337 55.3346 103.337 55.3346C103.388 55.3728 103.477 55.4616 103.388 55.6015C103.35 55.6526 103.311 55.7158 103.286 55.767C103.21 55.8687 103.134 55.9069 103.006 55.8304C102.968 55.8052 102.116 55.2326 101.137 55.2326C99.572 55.2326 98.9868 56.1996 98.9868 56.9244C98.9868 58.0057 99.8136 58.4763 101.098 58.8963C102.841 59.4941 103.948 60.1042 103.948 61.58C103.948 62.852 102.638 63.8442 101.175 63.8442C99.6608 63.8442 98.6432 62.9537 98.4781 62.8009C98.4016 62.7377 98.3378 62.6739 98.4399 62.5336Z"
        fill="white"
      />
      <path
        d="M21.7851 82.1626C22.3479 82.1626 22.8868 81.5544 22.8868 80.8087C22.8868 80.2694 22.5539 79.8572 22.1069 79.8572H21.0397L20.7179 82.1626H21.7851ZM19.7202 78.6632C19.7314 78.5482 19.835 78.4446 19.9493 78.4446H22.4053C23.5524 78.4446 24.3898 79.5347 24.3898 80.7402C24.3898 82.415 23.1741 83.5626 21.6934 83.5626H20.5231L20.1448 86.2589C20.1328 86.3739 20.0186 86.4778 19.915 86.4778H18.8134C18.6985 86.4778 18.6298 86.3739 18.6529 86.2589L19.7202 78.6632Z"
        fill="white"
      />
      <path
        d="M30.8881 82.1052C30.8881 80.8662 30.1307 79.8222 29.0403 79.8222C27.7208 79.8222 26.4701 81.2111 26.4701 82.8394C26.4701 84.0783 27.2275 85.1 28.3059 85.1C29.6374 85.1 30.8881 83.7465 30.8881 82.1052ZM29.2126 78.3297C31.0717 78.3297 32.4368 79.9706 32.4368 81.9217C32.4368 84.503 30.5665 86.5928 28.1454 86.5928C26.2753 86.5928 24.9214 84.9389 24.9214 83.0343C24.9214 80.4415 26.7686 78.3297 29.2126 78.3297Z"
        fill="white"
      />
      <path
        d="M33.7262 78.7207C33.7038 78.5596 33.8068 78.4446 33.9441 78.4446H34.9427C35.0232 78.4446 35.0918 78.5258 35.1031 78.6058L35.4935 82.9544H35.5396L37.8569 78.4557C37.8911 78.3885 37.9605 78.3297 38.0524 78.3297H38.2359C38.3278 78.3297 38.3847 78.3885 38.3963 78.4557L39.3254 82.9544H39.3719L41.0011 78.6058C41.0355 78.5258 41.1271 78.4446 41.2076 78.4446H42.2975C42.4465 78.4446 42.516 78.5596 42.4465 78.7207L39.4173 86.4314C39.3829 86.5227 39.2913 86.5928 39.2114 86.5928H39.039C38.9471 86.5928 38.8896 86.5337 38.8786 86.4665L37.7076 81.497H37.6621L35.1148 86.4665C35.0798 86.5337 35.0232 86.5928 34.9193 86.5928H34.7589C34.667 86.5928 34.5985 86.5227 34.5865 86.4314L33.7262 78.7207Z"
        fill="white"
      />
      <path
        d="M43.8296 78.6632C43.841 78.5482 43.9439 78.4446 44.0475 78.4446H48.2932C48.4075 78.4446 48.477 78.5482 48.465 78.6632L48.3276 79.6036C48.3156 79.7185 48.2127 79.8222 48.0977 79.8222H45.1604L44.897 81.7044H47.329C47.4323 81.7044 47.5128 81.8067 47.5015 81.9217L47.3635 82.8732C47.341 82.9991 47.2375 83.0918 47.1342 83.0918H44.7015L44.4148 85.1H47.3635C47.4784 85.1 47.5359 85.2022 47.5245 85.3172L47.3979 86.2589C47.3865 86.3739 47.2836 86.4778 47.1686 86.4778H42.9229C42.808 86.4778 42.7394 86.3739 42.7625 86.2589L43.8296 78.6632Z"
        fill="white"
      />
      <path
        d="M52.5413 82.1051C53.2645 82.1051 53.7458 81.4969 53.7458 80.7737C53.7458 80.258 53.425 79.8222 53.0005 79.8222H51.4288L51.107 82.1051H52.5413ZM50.086 78.6632C50.0973 78.5482 50.2003 78.4446 50.3039 78.4446H53.3334C54.458 78.4446 55.2721 79.4088 55.2721 80.5915C55.2721 81.9901 54.5379 82.8968 53.448 83.2404L54.3885 86.1778C54.4349 86.3278 54.3661 86.4778 54.1936 86.4778H53.1035C52.9892 86.4778 52.8856 86.4314 52.8511 86.2927L52.0136 83.3327H50.9235L50.5107 86.2589C50.4987 86.3739 50.3958 86.4778 50.2928 86.4778H49.1793C49.0643 86.4778 48.9958 86.3739 49.0189 86.2589L50.086 78.6632Z"
        fill="white"
      />
      <path
        d="M57.2504 78.6632C57.2614 78.5482 57.3647 78.4446 57.4683 78.4446H61.7139C61.8283 78.4446 61.8974 78.5482 61.8857 78.6632L61.7484 79.6036C61.7364 79.7185 61.6334 79.8222 61.5185 79.8222H58.5812L58.3175 81.7044H60.7498C60.8527 81.7044 60.9333 81.8067 60.9222 81.9217L60.7842 82.8732C60.7618 82.9991 60.6579 83.0918 60.5549 83.0918H58.122L57.8355 85.1H60.7842C60.8992 85.1 60.9566 85.2022 60.9453 85.3172L60.8183 86.2589C60.8073 86.3739 60.7043 86.4778 60.5894 86.4778H56.3437C56.2287 86.4778 56.1599 86.3739 56.1833 86.2589L57.2504 78.6632Z"
        fill="white"
      />
      <path
        d="M65.1599 85.0763C66.5596 85.0763 67.7186 83.7574 67.7186 82.0367C67.7186 80.785 67.007 79.8333 65.9055 79.8333H64.8274L64.0928 85.0763H65.1599ZM63.5076 78.6632C63.519 78.5482 63.6219 78.4446 63.7255 78.4446H66.2043C68.017 78.4446 69.3134 80.0745 69.3134 81.9327C69.3134 84.4232 67.4893 86.4778 65.0794 86.4778H62.5899C62.486 86.4778 62.4175 86.3739 62.4405 86.2589L63.5076 78.6632Z"
        fill="white"
      />
      <path
        d="M75.7909 81.8193C76.3992 81.8193 76.858 81.2783 76.858 80.6253C76.858 80.1544 76.5827 79.8096 76.1813 79.8096H75.2512L74.9648 81.8193H75.7909ZM75.4811 85.1239C76.0774 85.1239 76.5596 84.5955 76.5596 83.9523C76.5596 83.459 76.1693 83.0806 75.7445 83.0806H74.7924L74.4945 85.1239H75.4811ZM73.9207 78.6632C73.9318 78.5482 74.0347 78.4446 74.1497 78.4446H76.5365C77.6498 78.4446 78.4642 79.3049 78.4642 80.3155C78.4642 81.3709 77.6381 82.1863 77.0649 82.4387C77.5351 82.6209 78.1314 83.1381 78.1314 84.0335C78.1314 85.4211 77.099 86.4778 75.55 86.4778H73.0137C72.8991 86.4778 72.8303 86.3739 72.8533 86.2589L73.9207 78.6632Z"
        fill="white"
      />
      <path
        d="M81.1879 82.6098L79.3973 78.7207C79.3288 78.5707 79.4317 78.4446 79.5928 78.4446H80.6712C80.7976 78.4446 80.843 78.4907 80.8891 78.6057L82.0939 81.2445L84.0216 78.5482C84.0557 78.5021 84.1132 78.4446 84.2051 78.4446H85.4677C85.6395 78.4446 85.6739 78.593 85.571 78.743L82.6788 82.5984L82.1745 86.2589C82.1631 86.3739 82.0482 86.4778 81.9446 86.4778H80.8317C80.7167 86.4778 80.6596 86.3739 80.6712 86.2589L81.1879 82.6098Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M90.4478 78.5396H93.5407C94.3268 78.5396 94.9581 78.7263 95.4337 79.1093C95.9096 79.4927 96.1474 80.0106 96.1474 80.6735C96.1474 80.8495 96.1164 81.0361 96.0647 81.2329C95.951 81.6058 95.5682 82.1651 94.9786 82.424C95.5373 82.5999 95.9301 82.8798 96.1682 83.2423C96.406 83.6049 96.5197 83.9879 96.5197 84.3817C96.5197 85.7487 95.5164 86.6501 93.6443 86.6501H90.4478V78.5396ZM91.7097 81.9683H93.3029C94.3476 81.9683 94.875 81.4813 94.875 80.808C94.875 80.1347 94.4095 79.6895 93.3753 79.6895H91.7097V81.9683ZM91.7097 85.5003H93.6649C94.689 85.5003 95.2477 85.0136 95.2477 84.2782C95.2477 83.5739 94.6994 83.0869 93.5821 83.0869H91.7097V85.5003Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M117.795 86.6492H119.026V81.1182H117.795V86.6492Z"
        fill="#2CDD80"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M122.221 82.2264V84.671C122.221 85.334 122.542 85.5929 123.173 85.5929C123.297 85.5929 123.431 85.5824 123.566 85.5514V86.5975C123.369 86.6701 123.141 86.7114 122.904 86.7114C121.693 86.7114 120.99 86.0695 120.99 84.8678V82.2264H119.976V81.1182H120.99V79.409H122.221V81.1182H123.576V82.2264H122.221Z"
        fill="#2CDD80"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M116.157 80.2715C116.157 79.8193 116.524 79.451 116.976 79.451C117.428 79.451 117.796 79.8193 117.796 80.2715H119.027C119.027 79.1393 118.107 78.2181 116.976 78.2181C115.845 78.2181 114.926 79.1393 114.926 80.2715H116.157Z"
        fill="#2CDD80"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M100.49 82.362C100.386 82.341 100.273 82.3306 100.138 82.3306C99.1966 82.3306 98.7002 82.8799 98.7002 83.8431V86.6499H97.4695V81.1189H98.6692V81.9994C99.0106 81.3779 99.5175 81.067 100.19 81.067C100.324 81.067 100.417 81.0776 100.49 81.098V82.362Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M101.575 78.757C101.896 78.4254 102.392 78.4254 102.713 78.757C103.034 79.0782 103.034 79.5752 102.713 79.8965C102.392 80.2173 101.896 80.2173 101.575 79.8965C101.254 79.5752 101.254 79.0782 101.575 78.757ZM101.534 86.6497H102.765V81.1186H101.534V86.6497Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M104.504 81.8851C105.011 81.3049 105.683 81.015 106.5 81.015C106.8 81.015 107.121 81.0877 107.473 81.243C107.835 81.3879 108.104 81.6055 108.29 81.9059V78.2183H109.521V86.6496H108.321V85.7899C108.125 86.1112 107.845 86.3492 107.463 86.5047C107.09 86.66 106.759 86.7327 106.469 86.7327C105.693 86.7327 105.042 86.4529 104.525 85.8831C104.007 85.3134 103.749 84.6405 103.749 83.8737C103.749 83.128 103.997 82.4652 104.504 81.8851ZM105.456 82.631C105.156 82.9726 105.001 83.387 105.001 83.874C105.001 84.3607 105.156 84.7749 105.456 85.1166C105.766 85.4482 106.169 85.614 106.655 85.614C107.142 85.614 107.545 85.4482 107.845 85.1166C108.155 84.7749 108.311 84.3607 108.311 83.874C108.311 83.387 108.155 82.9726 107.845 82.631C107.535 82.2889 107.142 82.1235 106.655 82.1235C106.169 82.1235 105.766 82.2889 105.456 82.631Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M111.164 85.8517C110.657 85.2924 110.409 84.6296 110.409 83.8632C110.409 83.1277 110.657 82.4751 111.154 81.8951C111.661 81.3149 112.323 81.025 113.14 81.025C113.44 81.025 113.761 81.1078 114.112 81.2631C114.464 81.4185 114.743 81.6465 114.94 81.9572V81.1182H116.14V86.5769C116.14 87.4469 115.871 88.1411 115.343 88.6485C114.816 89.156 114.123 89.415 113.254 89.415C111.909 89.415 110.978 88.8557 110.471 87.7369L111.495 87.1465C111.878 87.9235 112.457 88.3169 113.233 88.3169C114.195 88.3169 114.909 87.7369 114.909 86.6287V85.7586C114.712 86.0797 114.433 86.3075 114.071 86.4629C113.709 86.6182 113.388 86.6909 113.099 86.6909C112.323 86.6909 111.671 86.4111 111.164 85.8517ZM114.475 82.6202C114.175 82.2885 113.771 82.123 113.285 82.123C112.799 82.123 112.395 82.2885 112.095 82.6202C111.795 82.9413 111.64 83.3557 111.64 83.8423C111.64 84.3292 111.795 84.7436 112.095 85.0853C112.406 85.4169 112.799 85.5823 113.285 85.5823C113.771 85.5823 114.164 85.4169 114.464 85.0853C114.775 84.7436 114.93 84.3292 114.93 83.8423C114.93 83.3557 114.775 82.9518 114.475 82.6202Z"
        fill="white"
      />
      <path
        d="M170.579 35.3059C170.205 35.3059 169.811 35.4604 169.394 35.7689C168.977 36.0778 168.625 36.4832 168.338 36.987L167.906 39.0132C168.108 39.4003 168.316 39.6909 168.531 39.8857C168.747 40.0796 169.042 40.1763 169.415 40.1763C169.76 40.1763 170.083 40.1005 170.385 39.9505C170.687 39.7989 170.953 39.5911 171.183 39.3245C171.412 39.0593 171.595 38.7466 171.732 38.3872C171.868 38.0282 171.937 37.6407 171.937 37.2241C171.937 36.6781 171.815 36.2208 171.571 35.8545C171.326 35.4885 170.995 35.3059 170.579 35.3059Z"
        fill="#A74E9E"
      />
      <path
        d="M212.434 35.3059C212.132 35.3059 211.841 35.3915 211.561 35.5639C211.281 35.7367 211.025 35.9669 210.796 36.253C210.566 36.5407 210.383 36.8676 210.246 37.2339C210.109 37.6002 210.041 37.9858 210.041 38.3872C210.041 38.919 210.178 39.3498 210.451 39.6811C210.724 40.0108 211.098 40.1763 211.571 40.1763C211.917 40.1763 212.243 40.0796 212.552 39.8857C212.861 39.6909 213.188 39.4003 213.533 39.0132L213.964 36.987C213.892 36.469 213.713 36.0594 213.425 35.7578C213.137 35.4559 212.807 35.3059 212.434 35.3059Z"
        fill="#A74E9E"
      />
      <path
        d="M198.576 35.3059C198.274 35.3059 197.98 35.3915 197.692 35.5639C197.404 35.7367 197.146 35.9625 196.916 36.2432C196.686 36.5224 196.503 36.8508 196.367 37.2241C196.23 37.5974 196.162 37.9858 196.162 38.3872C196.162 38.9333 196.294 39.3681 196.56 39.6909C196.826 40.0149 197.211 40.1763 197.714 40.1763C198.058 40.1763 198.382 40.0796 198.683 39.8857C198.985 39.6909 199.315 39.4003 199.675 39.0132L200.106 36.987C200.034 36.4832 199.858 36.0778 199.578 35.7689C199.298 35.4604 198.964 35.3059 198.576 35.3059Z"
        fill="#A74E9E"
      />
      <path
        d="M226.432 36.3514C226.87 36.2141 227.089 35.9671 227.089 35.6077C227.089 35.3636 226.989 35.1615 226.787 35.0045C226.586 34.846 226.32 34.7674 225.99 34.7674C225.573 34.7674 225.188 34.9287 224.837 35.2515C224.485 35.5755 224.194 36.0091 223.964 36.5564H224.115C225.222 36.5564 225.993 36.4876 226.432 36.3514Z"
        fill="#A74E9E"
      />
      <path
        d="M229.061 41.8139C228.609 42.1888 228.113 42.5115 227.574 42.785C227.035 43.0572 226.471 43.2663 225.883 43.4094C225.293 43.5524 224.704 43.6254 224.115 43.6254C223.382 43.6254 222.714 43.5104 222.111 43.2802C221.507 43.0503 220.993 42.7275 220.569 42.3107C220.146 41.8941 219.819 41.3901 219.589 40.8008C219.359 40.2131 219.244 39.5521 219.244 38.8182C219.244 37.8556 219.438 36.9505 219.826 36.1032C220.214 35.2556 220.745 34.516 221.421 33.8834C222.096 33.2505 222.89 32.755 223.802 32.396C224.715 32.0366 225.688 31.8572 226.723 31.8572C228.102 31.8572 229.176 32.1474 229.945 32.7298C230.713 33.3121 231.098 34.1203 231.098 35.1545C231.098 36.4342 230.512 37.3967 229.341 38.0423C228.17 38.689 226.435 39.0134 224.136 39.0134H223.512C223.512 39.6308 223.616 40.0656 223.824 40.3167C224.032 40.5681 224.388 40.6944 224.891 40.6944C225.81 40.6944 226.515 40.3056 227.003 39.5297L230.215 40.5636C229.898 41.0241 229.514 41.4406 229.061 41.8139ZM216.917 42.3754C216.73 43.2663 216.403 44.0703 215.936 44.7888C215.469 45.5072 214.891 46.1174 214.201 46.6214C213.511 47.1235 212.728 47.5151 211.852 47.7959C210.975 48.0751 210.034 48.2153 209.028 48.2153C207.893 48.2153 206.934 48.0286 206.151 47.6553C205.368 47.2821 204.718 46.7433 204.201 46.0391L206.83 43.7965C207.132 44.1853 207.527 44.5121 208.016 44.7774C208.504 45.044 209.05 45.1775 209.653 45.1775C209.999 45.1775 210.34 45.127 210.678 45.026C211.015 44.9249 211.324 44.7635 211.604 44.5403C211.885 44.3186 212.132 44.0268 212.348 43.6677C212.564 43.3083 212.721 42.8775 212.822 42.3754L212.973 41.6415C212.556 42.2462 212.028 42.6909 211.388 42.9786C210.749 43.2663 210.085 43.4094 209.395 43.4094C208.82 43.4094 208.306 43.2985 207.854 43.0756C207.401 42.8523 207.02 42.5478 206.712 42.1591C206.402 41.7719 206.169 41.3074 206.012 40.7686C205.853 40.2298 205.774 39.6446 205.774 39.0134C205.774 38.0211 205.947 37.091 206.291 36.221C206.637 35.3525 207.103 34.5946 207.693 33.9478C208.281 33.3011 208.967 32.7917 209.751 32.4168C210.534 32.0439 211.356 31.8572 212.218 31.8572C212.979 31.8572 213.616 32.0186 214.126 32.3426C214.635 32.6654 214.991 33.1369 215.192 33.7542L215.559 32.0732H219.115L216.917 42.3754ZM201.809 43.6254C201.191 43.6254 200.684 43.5104 200.289 43.2802C199.894 43.0503 199.696 42.6476 199.696 42.0735C199.696 42.0021 199.7 41.9292 199.707 41.8575C199.715 41.7858 199.725 41.7144 199.74 41.6415C199.222 42.3318 198.622 42.8355 197.94 43.1513C197.257 43.4668 196.564 43.6254 195.86 43.6254C195.228 43.6254 194.664 43.5133 194.168 43.2916C193.673 43.0686 193.252 42.7556 192.907 42.3527C192.563 41.9516 192.3 41.4703 192.121 40.9088C191.941 40.3492 191.851 39.7318 191.851 39.0554C191.851 38.0789 192.016 37.1555 192.347 36.287C192.677 35.417 193.123 34.6521 193.683 33.9914C194.244 33.3304 194.893 32.81 195.634 32.4282C196.374 32.048 197.153 31.8572 197.973 31.8572C198.662 31.8572 199.255 32.0227 199.75 32.3524C200.246 32.6837 200.58 33.1507 200.752 33.7542L202.046 27.6756H206.162L203.77 38.8829C203.727 39.0989 203.705 39.2714 203.705 39.4005C203.705 39.7599 203.9 39.9462 204.287 39.9604L203.555 43.4094C202.836 43.5524 202.254 43.6254 201.809 43.6254ZM189.286 43.4094H185.191L187.605 32.0732H191.701L189.286 43.4094ZM181.916 36.6855L180.493 43.4094H176.398L178.812 32.0732H182.562L182.088 34.2286C182.634 33.4666 183.234 32.8814 183.888 32.4718C184.541 32.0619 185.191 31.8572 185.838 31.8572C185.996 31.8572 186.104 31.8572 186.162 31.8572C186.218 31.8572 186.269 31.8642 186.312 31.8781L185.536 35.5641C184.803 35.5641 184.114 35.65 183.467 35.8225C182.821 35.9952 182.303 36.2826 181.916 36.6855ZM175.719 39.2281C175.367 40.1051 174.893 40.8697 174.297 41.5237C173.701 42.1774 173.015 42.6909 172.238 43.0642C171.462 43.4375 170.651 43.6254 169.803 43.6254C168.208 43.6254 167.21 42.9647 166.808 41.6415L166.441 43.4094H162.884L166.225 27.6756H170.321L169.027 33.7542C169.429 33.165 169.95 32.7017 170.59 32.3638C171.229 32.0268 171.908 31.8572 172.627 31.8572C173.201 31.8572 173.715 31.9681 174.167 32.191C174.621 32.4143 175.001 32.7269 175.31 33.1283C175.619 33.531 175.852 34.0123 176.01 34.5722C176.168 35.1334 176.248 35.7438 176.248 36.4048C176.248 37.411 176.071 38.3524 175.719 39.2281ZM188.532 27.6756H192.627L191.894 31.1245H187.8L188.532 27.6756ZM195.912 7.42747e-05C174.955 7.42747e-05 157.967 16.9888 157.967 37.945C157.967 58.9021 174.955 75.8909 195.912 75.8909C216.869 75.8909 233.857 58.9021 233.857 37.945C233.857 16.9888 216.869 7.42747e-05 195.912 7.42747e-05Z"
        fill="#A74E9E"
      />
    </symbol>
  </svg>
</template>
